// extracted by mini-css-extract-plugin
module.exports = {"container":"AudioWave_container__3bH0p","bar":"AudioWave_bar__8nTB0"};